// src/components/GalleryGrid.jsx
import React, { useMemo, useState } from "react";

const ImgCard = ({ photo, index, onClick }) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  return (
    
    <div
      className="group relative cursor-pointer overflow-hidden rounded-2xl shadow-xl transition-transform duration-300 hover:scale-[1.025]"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
    >
      <div className="aspect-[3/2] overflow-hidden relative">
        {!loaded && !failed && (
          <div className="absolute inset-0 animate-pulse bg-white/5" />
        )}

        {failed ? (
          <div className="absolute inset-0 bg-black/30 border border-white/10 flex items-center justify-center">
            <div className="text-center px-4">
              <p className="text-sm text-white/70">Image failed to load</p>
              <p className="mt-1 text-xs text-white/40 break-all">{photo.src}</p>
            </div>
          </div>
        ) : (
          <img
            src={photo.src}
            alt={photo.alt || ""}
            className={`w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 ${
              loaded ? "opacity-100" : "opacity-0"
            }`}
            loading={index < 6 ? "eager" : "lazy"}
            decoding="async"
            fetchPriority={index < 2 ? "high" : "auto"}
            onLoad={() => setLoaded(true)}
            onError={() => setFailed(true)}
          />
        )}

        <div className="absolute bottom-0 left-0 right-0 px-4 py-3 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-sm text-[#f0eae2] tracking-wide italic">
            {photo.caption}
          </p>
        </div>
      </div>
    </div>
  );
};

const GalleryGrid = ({ photos, onPhotoClick }) => {
  const safePhotos = useMemo(() => Array.isArray(photos) ? photos : [], [photos]);

  if (safePhotos.length === 0) {
    return (
      <div className="px-2 sm:px-4 py-10 text-center text-white/60">
        No photos found.
      </div>
    );
  }

  return (
    <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 px-2 sm:px-4">
      {safePhotos.map((photo, i) => (
        <ImgCard
          key={photo.id || photo.src || i}
          photo={photo}
          index={i}
          onClick={() => onPhotoClick?.(photo)}
        />
      ))}
    </div>
  );
};

export default GalleryGrid;
